import { type PartialAddress } from '~/types/address';

import { countryNames } from '@vestigas/utils';

import { joinElements } from './array';

/**
 * Renders an address object to a single string.
 *
 * @example addressToString({buildingNumber: '19', city: 'Berlin', country: 'DE', postCode: '12345', streetName: 'Musterstraße'})
 * => 'Musterstraße 19, 12345 Berlin, DE'
 */
export const addressToString = (address?: PartialAddress | null) => {
  if (!address) {
    return '';
  }

  const { buildingNumber, city, country, postCode, streetName } = address;
  const addressString = joinElements(
    [
      joinElements([streetName, buildingNumber]),
      joinElements([postCode, city]),
      joinElements([country ? countryNames.getName(country, 'de') : undefined]),
    ],
    ', ',
  );

  return addressString;
};
